import { jwtDecode } from 'jwt-decode';
import { getNonce } from 'shared/services/local-storage';

type SignInIdTokenClaims = {
  nonce?: string;
};

// Guards both providers: Google's credential takes no rawNonce, and Apple's runs after a sign-out.
export const hasMatchingSignInNonce = (idToken: string): boolean => {
  const expected = getNonce()?.hashed;

  if (!expected) {
    return false;
  }

  try {
    return jwtDecode<SignInIdTokenClaims>(idToken).nonce === expected;
  } catch {
    return false;
  }
};
